/**
 * Cart button pinned on the screen (community pages only).
 *
 * It appears as soon as something is in the cart, bounces when a new product is
 * added and opens the cart drawer (`CartSidebar`), which groups the lines per
 * shop — every shop is paid on its own page.
 */
import React, { useEffect, useRef, useState } from 'react';
import { FiShoppingCart } from 'react-icons/fi';
import { useCart } from '../../contexts/CartContext';
import { useLanguage } from '../../i18n';
import { BLUE } from './brand';

export default function FloatingCart() {
  const { items, open, setOpen } = useCart();
  const { t } = useLanguage();
  const [bump, setBump] = useState(false);
  const previous = useRef(0);

  const count = items.reduce((sum, i) => sum + i.quantity, 0);

  // Little bounce when a product was just added.
  useEffect(() => {
    if (count > previous.current) {
      setBump(true);
      const id = setTimeout(() => setBump(false), 700);
      previous.current = count;
      return () => clearTimeout(id);
    }
    previous.current = count;
    return undefined;
  }, [count]);

  if (count === 0 || open) return null;

  return (
    <button
      type="button"
      onClick={() => setOpen(true)}
      title={`${t('yourCart')} (${count})`}
      aria-label={`${t('yourCart')} (${count})`}
      className={`fixed right-4 bottom-20 lg:bottom-6 z-[1150] w-14 h-14 rounded-full shadow-2xl
                  flex items-center justify-center text-white transition
                  ${bump ? 'anim-pop scale-110' : ''}`}
      style={{ background: BLUE }}
    >
      <FiShoppingCart className="w-6 h-6" />
      <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-red-500 text-white text-[11px] font-bold flex items-center justify-center">
        {count}
      </span>
    </button>
  );
}
